import React from "react";
import "./laoder.css";


export default function RotatingLinesLoader() {
  return (
    <div className="loader-container">
      <div className="loader-wrapper">
        {Array.from({ length: 12 }).map((_, i) => (
          <div
            key={i}
            className="loader-line"
            style={{ transform: `rotate(${i * 30}deg) translateY(-20px)` }}
          />
        ))}
      </div>
    </div>
  );
}
